import {
    BottomNavigation,
    BottomNavigationAction,
    CircularProgress,
    createStyles,
    Grid,
    Paper,
    Theme,
    WithStyles,
    withStyles,
} from "@material-ui/core";
import { AddBoxOutlined, SensorsOutlined } from "@material-ui/icons";
import "@theankur/swiper/swiper.scss";
import classNames from "classnames";
import firebase from "firebase";
import { parse } from "query-string";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import {
    getGlobalUserId,
    setGlobalAuthToken,
    setGlobalUserId,
    setReqHeaderXAppName,
} from "shared/src/framework/network/headers";
import { userAdd } from "shared/src/network/requests/user/user-req";
import { Analytic } from "../analytic/analytic";
import { withRouter, WithRouterProps } from "../hoc/withRouter";
import { setBottomNavigation } from "./../redux/app/AppSlice";
import { RootState } from "./../redux/store";
import { commonClasses, spacing } from "./../styles";

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        ...spacing(theme),
        circleBorder: {
            //background: "#ffc0c0",
            borderRadius: "50%",
            textAlign: "center",
            verticalAlign: "middle",
            width: "30px",
            height: "30px",
            padding: "3px",
        },
        iconOnSelect: {
            background: "#1565C0",
            color: "white",
        },
        hide: {
            display: "none",
        },
        fullWidthHeight: {
            width: "100%",
            height: "100%",
        },
        overflowYScroll: {
            overflowY: "auto",
        },
        swipeableViews: {
            height: "calc(100% - 88px)", // 32px for top, 56px for bottom
        },
    });

const mapState = (state: RootState) => ({
    activeBottomNavigation: state.app.activeBottomNavigation,
});

const mapDispatch = {
    setBottomNavigation,
};

const connector = connect(mapState, mapDispatch);

type Props = WithStyles<typeof styles> & ConnectedProps<typeof connector> & WithRouterProps;

type State = {
    isLoadingAuth: boolean;
};

class Component extends React.Component<Props, State> {
    unsubscribeAuthStateObserver?: firebase.Unsubscribe;
    constructor(props: Props) {
        super(props);
        this.state = {
            isLoadingAuth: true,
        };
        Analytic.setTabIndex("poll");
        setReqHeaderXAppName("web");
    }

    componentDidMount = async () => {
        const userId = getGlobalUserId();
        if (!userId) {
            this.unsubscribeAuthStateObserver = firebase.auth().onAuthStateChanged((user) => {
                const userId = user?.uid;
                userAdd({ userId }).then((res) => {
                    setGlobalAuthToken(res.token);
                    setGlobalUserId(res.userId);
                    Analytic.setUserId(res.userId);
                    this.setState({ isLoadingAuth: false });
                });
            });
        } else {
            Analytic.setUserId(userId);
            this.setState({ isLoadingAuth: false });
        }
    };

    getIsFromNotificationFromQueryParams = () => {
        const queryStringParams = parse(window.location.search);
        return !!queryStringParams.notification;
    };

    componentWillUnmount = () => {
        this.unsubscribeAuthStateObserver?.();
    };

    render = () => {
        const { classes, location, matchPath } = this.props;
        const isCreatePollActive = matchPath("create-flash", location.pathname);
        const { isLoadingAuth } = this.state;
        if (isLoadingAuth) {
            return (
                <Grid
                    container
                    className={classes.fullHeight}
                    alignItems="center"
                    justifyContent="center">
                    <CircularProgress />
                </Grid>
            );
        }
        return (
            <>
                <div className={classNames(classes.swipeableViews)}>
                    <Outlet />
                </div>
                <Paper sx={{ width: "100%", position: "fixed", bottom: "0" }} elevation={3}>
                    <BottomNavigation showLabels>
                        <BottomNavigationAction
                            label="Flashes"
                            component={Link}
                            to="/"
                            icon={
                                <SensorsOutlined
                                    className={classNames(classes.circleBorder, {
                                        [classes.iconOnSelect]: !isCreatePollActive,
                                    })}
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="Create"
                            component={Link}
                            to="/create-flash"
                            icon={
                                <AddBoxOutlined
                                    className={classNames(classes.circleBorder, {
                                        [classes.iconOnSelect]: isCreatePollActive,
                                    })}
                                />
                            }
                        />
                        {/* <BottomNavigationAction
                            label="Activity"
                            component={Link}
                            to="/activity"
                            icon={
                                <NotificationsOutlined
                                    className={classNames(classes.circleBorder, {
                                        [classes.iconOnSelect]: tabValue === 2,
                                    })}
                                />
                            }
                        /> */}
                    </BottomNavigation>
                </Paper>
            </>
        );
    };
}

const Home = withStyles(styles)(withRouter(Component));

export default connector(Home);
